import { FunctionComponent } from "react";
import { Icon } from "../Icon";
import FooterInfo from "./Info";

const Footer: FunctionComponent = () => {
  return (
    <section className="footer_container">
      <div className="footer_icon__container">
        <Icon iconName="rtabak_white_icon" className="footer_icon__main" />
      </div>
      <div className="footer_main">
        <FooterInfo />
        <p className="footer_info_rights">
          ©2024 todos los derechos reservados
        </p>
      </div>
    </section>
  );
};

export default Footer;
